import { render, staticRenderFns } from "./TheVariationsFields.vue?vue&type=template&id=54b6a7e3&scoped=true&"
import script from "./TheVariationsFields.vue?vue&type=script&lang=ts&"
export * from "./TheVariationsFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b6a7e3",
  null
  
)

export default component.exports